document.addEventListener("DOMContentLoaded", function () {
  const megaMenus = document.querySelectorAll(".mega-menu");

  megaMenus.forEach(menu => {
    menu.addEventListener("toggle", function () {
      if (this.open) {
        document.body.classList.add("mega-menu-open");
      } else {
        const anyMenuOpen = Array.from(megaMenus).some(menu => menu.open);
        if (!anyMenuOpen) {
          document.body.classList.remove("mega-menu-open");
        }
      }
    });
  });
});